import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";
import { LoginOption, isMlsSsoLoginOption } from "./login-options-form-helpers";

export const loginSSOFormSchema = yup
  .object({
    email: yup
      .string()
      .email()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("E-mail"),
  })
  .required();

export type LoginSSOSchema = typeof loginSSOFormSchema.__outputType;

export const isValidSsoProvider = (
  provider: string,
  loginOptions: LoginOption[]
): boolean => {
  const option = loginOptions.find((o) => o.id === provider);
  return !!option && isMlsSsoLoginOption(option);
};
